{
  "08f13c0eaa454ceb": "Descargar para Android",
  "0cf3a3f729944fa0": "Solicitud Enviada",
  "0d0e02e4ceed56d5": "Expandir línea de tiempo",
  "19766ed6ccb2f4a3": "Cancelar",
  "1cd58655ba2331c9": "Error al cargar el documento",
  "2074af6eeb2b3275": "Descarga la aplicación Clipboard Workplace para ver tu horario, publicar turnos y enviar mensajes a tus trabajadores mientras estás en movimiento.",
  "2b6a38b89f9c7b30": "Día siguiente",
  "3b7ea51793e9d906": "Limpiar búsqueda",
  "43d6f08e4edb5431": "Hora local: {{localTime}}",
  "51ade6c018ded413": "No hay notificaciones actuales",
  "59ebe97eedd6795e": "Editar tiempo",
  "5fbc1e7e7e83b837": "Colapsar línea de tiempo",
  "6248346eae8d0df7": "Aumentar cantidad",
  "685e43d81887725c": "{{currentStep}} de {{totalSteps}}",
  "6c15c542ce67f0a9": "Disminuir cantidad",
  "71139c3ae28e7d90": "Establecer límite",
  "7587b4b51fb544fa": "Esta semana ya ha terminado",
  "7707b94233940ee1": "Descargar para iOS",
  "788011833a5a0f22": "Notificaciones",
  "7a0d06d516580b7f": "Cerrar cajón",
  "7d9eb7acb13e2462": "Cerrar",
  "916d8ebfe068b43a": "Editar límite",
  "926cc946fedafbf5": "Error al cargar las notificaciones. Por favor, intenta de nuevo más tarde.",
  "93483c938871b25a": "Límite semanal",
  "96f2f0811df88d8f": "pm",
  "999d5198e33dfdb4": "Desestimar coachmark",
  "99af6606ff9d6cd5": "Menú",
  "ab6db599234d2636": "am",
  "b37c7879f6c359f6": "No registrado",
  "c8df66c5fe3f97d0": "Cerrar diálogo",
  "d6eafe8235910042": "Descargar",
  "df0fe79898ef413e": "Imprimir",
  "e4a1e89ee1db53ce": "Día anterior",
  "ea61bc15688d1e48": "¡Copiado!",
  "eb0c3ed107b24c4b": "Sin límite semanal",
  "efd29d8c54d0a8ff": "Lleva Clipboard contigo",
  "efe7287d10ef5fe2": "Solicitar aumento"
}
